type ProductType = 0 | 1 | 2 | 3  // 有效值：1=金币充值，2=订阅会员，3=金币充值 & 订阅会员
export async function getRechargeProducts(monetization: ProductType = 0) {
    try {
        const res = await useClientFetch('/api/pay/get-product-list', {
            method: 'GET',
            key: (Date.now()).toString(),
            query: {
                monetization
            }
        })
        const realData = res.data.value
        if(realData?.code === 0) {
            return realData
        }
        return []
    } catch (err) {
        console.error(`请求商品异常`, err)
        return []
    }
}
